import React from 'react';
import {useGetAllVendorSettingsQuery} from "../../store/Api";
import {Dropdown} from "@fluentui/react/lib/Dropdown";
import { renderVendorNameFromAllSettings } from '../../logic/Product';
import {IProductBundleItem} from "../../models/ProductBundles";

interface IProductBundleVendorSelectionProps {
    item: IProductBundleItem;
    onSelectedItemChanged: (item: IProductBundleItem) => void;
}

const ProductBundleVendorSelection: React.FC<IProductBundleVendorSelectionProps> = (props) => {
    const vendorSettings = useGetAllVendorSettingsQuery();
    const [selection, setSelection] = React.useState<string | undefined>(props.item.details?.source);

    React.useEffect(() => {
        if(props.item.details?.source && props.item.details?.source !== '') {
            setSelection(props.item.details?.source);
        }
        else{
            setSelection('LowestInStock');
        }
    }, [props.item.details?.source]);

    return <Dropdown
        selectedKey={selection}
        options={[
            {key: 'LowestInStock', text: 'Lowest Price In Stock'},
            {key: 'LowestPrice', text: 'Lowest Price'},
            ...(props.item?.vendors?.map(vendor => (
                {
                    key: vendor.vendorName ?? '',
                    text: `${renderVendorNameFromAllSettings(vendor.vendorName, vendorSettings.data)}${vendor.inStock ? '' : ' (Out of Stock)'} - ${(vendor?.cost ?? 0).toFixed(2)}`
                }
            )) ?? [])
        ]}
        onChange={(e,d) => {
            props.onSelectedItemChanged({
                ...props.item,
                details: {
                    ...props.item.details,
                    source: (d?.key ?? '') as string,
                }
            });
            
        }}
    />
}

export default ProductBundleVendorSelection;